import { useEffect, useState } from "react";
import api from "@api";
import "./DirectoryLeagueClaims.css"

function DirectoryLeagueClaims() {
 const [claims, setClaims] = useState([]);
 const [rejectingId, setRejectingId] = useState(null);
 const [rejectReason, setRejectReason] = useState("");
 const [expandedId, setExpandedId] = useState(null);

 const fetchClaims = async () => {
  const res = await api.get("/api/directory-league-claims", {
   withCredentials: true,
  });
  setClaims(res.data || []);
 };

 useEffect(() => {
  fetchClaims();
 }, []);

 const approve = async (id) => {
  await api.post(`/api/directory-league-claims/${id}/approve`, {}, { withCredentials: true });
  fetchClaims();
 };

 const reject = async (id) => {
  if (!rejectReason.trim()) {
   alert("Please provide a rejection reason.");
   return;
  }

  await api.post(
   `/api/directory-league-claims/${id}/reject`,
   { admin_notes: rejectReason },
   { withCredentials: true }
  );

  setRejectingId(null);
  setRejectReason("");
  fetchClaims();
 };

 const deleteClaim = async (id) => {
  const confirmed = window.confirm("Delete this claim permanently?");
  if (!confirmed) return;

  await api.delete(`/api/directory-league-claims/${id}`, {
   withCredentials: true,
  });

  fetchClaims();
 };

 const unclaimLeague = async (leagueId) => {
  const confirmed = window.confirm(
   "Unclaim this league? This will remove ownership."
  );
  if (!confirmed) return;

  await api.post(
   `/api/admin/directory/${leagueId}/unclaim`,
   {},
   { withCredentials: true }
  );

  fetchClaims();
 };

 return (
  <div className="dlc-container">
   <h2 className="dlc-title">Directory League Claims</h2>

   <div className="dlc-table-wrapper">
    <table className="dlc-table">
     <thead>
      <tr>
       <th>League</th>
       <th>Name</th>
       <th>Role</th>
       <th>Submitted</th>
       <th>Status</th>
       <th>Actions</th>
      </tr>
     </thead>

     <tbody>
      {claims.map((c) => (
       <>
        <tr
         key={c.id}
         className="dlc-row"
         onClick={() =>
          setExpandedId(expandedId === c.id ? null : c.id)
         }
        >
         <td className="dlc-league">
          {c.directoryLeague?.name || c.directory_league_id}
         </td>

         <td>{c.full_name}</td>

         <td>{c.role_title}</td>

         <td className="dlc-date">
          {new Date(c.createdAt).toLocaleString([], {
           month: "short",
           day: "numeric",
           hour: "2-digit",
           minute: "2-digit"
          })}
         </td>

         <td className={`dlc-status dlc-status-${c.status}`}>
          {c.status}
         </td>

         <td className="dlc-actions" onClick={(e) => e.stopPropagation()}>

          {c.status === "pending" && (
           <>
            <button
             className="dlc-btn dlc-btn-approve"
             onClick={() => approve(c.id)}
            >
             Approve
            </button>

            {rejectingId === c.id ? (
             <div className="dlc-reject-box">
              <textarea
               placeholder="Reason for rejection"
               value={rejectReason}
               onChange={(e) => setRejectReason(e.target.value)}
              />

              <div className="dlc-reject-actions">
               <button
                className="dlc-btn dlc-btn-reject"
                onClick={() => reject(c.id)}
               >
                Confirm Reject
               </button>

               <button
                className="dlc-btn"
                onClick={() => {
                 setRejectingId(null);
                 setRejectReason("");
                }}
               >
                Cancel
               </button>
              </div>
             </div>
            ) : (
             <button
              className="dlc-btn dlc-btn-reject"
              onClick={() => setRejectingId(c.id)}
             >
              Reject
             </button>
            )}
           </>
          )}

          {c.status !== "approved" && (
           <button
            className="dlc-btn dlc-btn-delete"
            onClick={() => deleteClaim(c.id)}
           >
            Delete
           </button>
          )}

          {c.status === "approved" && c.directory_league_id && (
           <button
            className="dlc-btn dlc-btn-unclaim"
            onClick={() => unclaimLeague(c.directory_league_id)}
           >
            Unclaim
           </button>
          )}

         </td>
        </tr>

        {expandedId === c.id && (
         <tr className="dlc-expand">
          <td colSpan="6">
           <div className="dlc-expand-content">

            <div>
             <strong>Username:</strong> {c.user?.username || "—"}
            </div>

            <div>
             <strong>Account Email:</strong> {c.user?.email || "—"}
            </div>

            <div>
             <strong>Contact Email:</strong> {c.contact_email || "—"}
            </div>

            <div>
             <strong>Message:</strong> {c.message || "—"}
            </div>

           </div>
          </td>
         </tr>
        )}
       </>
      ))}
     </tbody>
    </table>
   </div>
  </div>
 );
}

export default DirectoryLeagueClaims;